import {useState} from 'react'
import { NavLink } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import PieActiveArc from "components/PieChart/PieChart"

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card"
import PersonalDataCharts from "./personalDataCharts/PersonalDataCharts"
import { availableSizesData, yesAvailableSizesAvatar, notSureAvailableSizesAvatars, noAvailableSizesAvatars } from './data/product_availableSizes';
import { npsData, veryLikelyNpsAvatars, notLikelyNpsAvatars } from './data/product_nps';
import { feedbackData, likeAvatars, dontLikeAvatars, notDecidedAvatars } from './data/product_standard_feedback';
import { useMaterialUIController, setLayout } from "context";
import MDTypography from "components/MDTypography";
import MDAvatar from 'components/MDAvatar';
import Tooltip from "@mui/material/Tooltip";

import team1 from "assets/images/team-1.jpg"
import team2 from "assets/images/team-2.jpg"
import team3 from "assets/images/team-3.jpg"
import team4 from "assets/images/team-4.jpg"
import team5 from "assets/images/team-5.jpg"

import product3 from "assets/images/product3.jpg"

/* eslint-disable react/prop-types */

function ProductReport() {
  const [showAvailableSizesAvatars, setshowAvailableSizesAvatars] = useState(null)
  const [availableSizes, setAvailableSizes] = useState("")

  const [showNpsAvatars, setShowNpsAvatars] = useState(null)
  const [nps, setNps] = useState("")

  const [showFeedbackAvatars, setShowFeedbackAvatars] = useState(null)
  const [feedback, setFeedback] = useState("")

  function onAvailableSizes(id){
      if (id == 0){
        setshowAvailableSizesAvatars(yesAvailableSizesAvatar)
        setAvailableSizes("satisfied")
      }
      if(id == 1){
        setshowAvailableSizesAvatars(notSureAvailableSizesAvatars)
        setAvailableSizes("not sure if satisfied")
      }
      if(id == 2) {
        setshowAvailableSizesAvatars(noAvailableSizesAvatars)
        setAvailableSizes("not satisifed")
      }
  }

  function onNps(id){
    if (id == 0){
        setShowNpsAvatars(veryLikelyNpsAvatars)
      setNps("very likely")
    }
    if(id == 1){
        setShowNpsAvatars(notLikelyNpsAvatars)
        setNps("Not likely at all")
    }
  }

  function onFeedBack(id){
    if (id == 0){
        setShowFeedbackAvatars(likeAvatars)
        setFeedback("like")
    }
    if(id == 1){
        setShowFeedbackAvatars(notDecidedAvatars)
        setFeedback("are not decided if they like")
    }
    if(id == 2) {
        setShowFeedbackAvatars(dontLikeAvatars)
        setFeedback("don't like")
    }
  }

  const participants = [{name: "ElenaShadow", image:team1}, {name: "AlexPhoenix", image:team2}, {name: "EmilyJhonson", image:team3}, {name:"ChrisTaylor", image:team4}, {name:"LaraAdventure", image:team5}]

  const renderParticipants = participants.map((participant) => (
    <Tooltip key={participant.name} title={participant.name} placement="bottom">
      <MDAvatar
        src={participant.image}
        alt={participant.name}
        size="lg"
        sx={({ borders: { borderWidth }, palette: { white } }) => ({
          border: `${borderWidth[2]} solid #F2EFF8`,
          cursor: "pointer",
          position: "relative",
          ml: -1.25,

          "&:hover, &:focus": {
            zIndex: "10",
          },
        })}
      />
    </Tooltip>
  ));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
          <Card sx={{ height: "100%" }}>
            <MDBox pt={3} pb={2} px={2}>
              <MDBox
                component="ul"
                display="flex"
                flexDirection="column"
                p={0}
                m={0}
                sx={{ listStyle: "none" }}
              >
              <MDTypography variant="h5" fontWeight="medium" gutterBottom>
                Product campaign report
              </MDTypography>
                <MDBox display="flex" mt={2} alignItems="center">
                    <img src={product3} width={80} style={{borderRadius:20}}/>
                    <MDBox ml={3} display="block">
                        <MDTypography display="block" variant="button" color="text" fontWeight="medium" gutterBottom>
                            LONG PUFFER JACKET
                        </MDTypography>
                        <MDTypography display="block" variant="button" color="text" fontWeight="regular" >
                            Long puffer jacket with a high neck and adjustable hood with snap buttons.
                        </MDTypography>
                        <MDTypography display="block" variant="button" color="text" fontWeight="regular" gutterBottom>
                            08281421
                        </MDTypography>
                        <MDTypography display="block" variant="button" color="error" fontWeight="medium" gutterBottom>
                            99.99 $
                        </MDTypography>
                    </MDBox>
                </MDBox>
              <MDBox>
              <MDBox mt={3}>
                <MDTypography display="block" variant="h6" color="text" fontWeight="bold" gutterBottom>
                    Target avatar
                </MDTypography>
                <MDTypography display="flex" variant="button" color="text" fontWeight="medium" >
                    Age: 
                    <MDTypography display="flex" variant="button" color="text" fontWeight="regular" >
                    &nbsp;18 - 25
                    </MDTypography>
                </MDTypography>
                <MDTypography display="flex" variant="button" color="text" fontWeight="medium" gutterBottom> 
                    Gender:
                    <MDTypography display="flex" variant="button" color="text" fontWeight="regular" gutterBottom>
                    &nbsp;Female
                    </MDTypography>
                </MDTypography>
              </MDBox>
              <MDBox mt={3}>
                <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                    Survey product report
                </MDTypography>
              </MDBox>
                <Card sx={{ mt:2, padding: "2rem", backgroundColor: "#F8F9FA" }}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="block" justifyContent="center" alignItems="center" width={"45%"}>
                      <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem"}}>
                        Available sizes
                      </MDTypography>
                      <PieActiveArc onClickId={onAvailableSizes} data={availableSizesData} legendHidden={false}/>
                    </MDBox>
                    <MDBox width={"55%"}>
                      {showAvailableSizesAvatars && 
                        <PersonalDataCharts data={showAvailableSizesAvatars} title={"Avatars with that are " + availableSizes + " with the available sizes."}/>
                      }
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                <Card sx={{ padding: "2rem", backgroundColor: "#F8F9FA"}}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="block" justifyContent="center" width={"45%"}>
                      <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem"}}>
                        Net Promoter Score (NPS)
                      </MDTypography>
                      <PieActiveArc onClickId={onNps} data={npsData} legendHidden={false}/>
                    </MDBox>
                    <MDBox width={"55%"}>
                      {showNpsAvatars && 
                        <PersonalDataCharts data={showNpsAvatars} title={"Avatars that are " + nps + " to recommand this product."}/>
                      }
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                <Card sx={{ padding: "2rem", backgroundColor: "#F8F9FA"}}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox display="block" justifyContent="center" width={"45%"}>
                      <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem"}}>
                        Standard Feedback
                      </MDTypography>
                      <PieActiveArc onClickId={onFeedBack} data={feedbackData} legendHidden={false}/>
                    </MDBox>
                    <MDBox width={"55%"}>
                      {showFeedbackAvatars && 
                        <PersonalDataCharts data={showFeedbackAvatars} title={"Avatars that " + feedback + " the product."}/>
                      }
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox>
              <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem", marginBottom: "1rem"}}>
                Discounts reports
              </MDTypography>
              <Card sx={{ mt:2, padding: "2rem", backgroundColor: "#F8F9FA" }}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDBox display="block" justifyContent="center" width={"45%"}>
                  <MDTypography display="block" variant="button" fontWeight="medium" >
                    MOBITZ spent:
                    <MDTypography variant="button" fontWeight="bold" color="error" >
                        &nbsp;10,000
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium" gutterBottom>
                    MOBITZ charged:
                    <MDTypography variant="button" fontWeight="bold" color="success" >
                        &nbsp;12,000
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium" sx={{marginTop:1}}>
                    Discounts TOTAL:
                    <MDTypography variant="button" fontWeight="bold" color="error" >
                        &nbsp;700 $
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    Discounts lvl 2:
                    <MDTypography variant="button" fontWeight="bold" color="text" >
                        &nbsp;200 $
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    Discounts lvl 3:
                    <MDTypography variant="button" fontWeight="bold" color="text" >
                        &nbsp;500 $
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    No. discounts lvl 2:
                    <MDTypography variant="button" fontWeight="bold" color="text" >
                        &nbsp;12
                    </MDTypography>
                  </MDTypography>
                    <MDTypography display="block" variant="button" fontWeight="medium">
                  No. discounts lvl 3
                    <MDTypography variant="button" fontWeight="bold" color="text" >
                        &nbsp;20
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium" sx={{marginTop:1}}>
                    Sales TOTAL:
                    <MDTypography variant="button" fontWeight="bold" color="success" >
                        &nbsp;56
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    Sales lvl 2:
                    <MDTypography variant="button" fontWeight="bold" color="text" >
                        &nbsp;22
                    </MDTypography>
                  </MDTypography>
                  <MDTypography display="block" variant="button" fontWeight="medium">
                    Sales lvl 3:
                    <MDTypography variant="button" fontWeight="bold" color="text" >
                        &nbsp; 34
                    </MDTypography>
                  </MDTypography>
                </MDBox>
                <MDBox width={"55%"}>
                  <PersonalDataCharts data={noAvailableSizesAvatars} title={"Avatars in discount campaign"}/>
                </MDBox>
                </MDBox>
              </Card>
              </MDBox>
              <MDBox mt={3}>
                <MDBox display="flex" justifyContent="space-between" p="2rem">
                <MDBox display="block" justifyContent="center" width={"45%"}>
                    <MDTypography variant="h6" fontWeight="bold" gutterBottom sx={{marginTop:"1rem", marginBottom: "1rem"}}>
                    Avatars that took part in this campaign
                    </MDTypography>
                    <MDBox display="flex">{renderParticipants}</MDBox>
                </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
            </MDBox>
          </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ProductReport;
